import { useEffect, useState } from 'react';
import { apiRequests } from '../../shared/api/apiRequests.js';
import { dateToString } from '../../shared/utils/parseDate.js';
import { Pagination } from '../../features/Pagination/index.js';
import { PageBar } from '../../shared/ui/PageBar';
import { EntityCard } from '../../shared/ui/EntityCard';

const CategoriesOfEventsPage = () => {
  const [data, setData] = useState([]);
  const [searchValue, setSearchValue] = useState('');

  const getData = (count = 5, offset = 0) => {
    apiRequests.events.getCategories(count, offset).then((res) => setData(res));
  };

  const handleSearch = () => {
    if (searchValue === '') {
      getData();
    } else {
      apiRequests.events.getCategoriesFiltered(searchValue).then((res) => setData(res));
    }
  };

  useEffect(() => {
    // getData()
  }, []);

  const handleDelete = (id) => {
    apiRequests.events.deleteCategory(id).then(() =>
      setData((prev) => ({
        totalCount: prev.totalCount,
        items: prev.items.filter((i) => i.id !== id),
      })),
    );
  };

  return (
    <>
      <PageBar
        searchValue={searchValue}
        onSearchChange={setSearchValue}
        onSearch={handleSearch}
        searchPlaceholder="Поиск категорий..."
        createLink="/events/categories/create"
      />

      <div className="mb-3">
        {data.items?.length === 0 ? (
          <p className="text-center">По вашему запросу ничего не найдено</p>
        ) : (
          data.items?.map((item) => (
            <EntityCard
              key={item.id}
              title={item.title}
              fields={[
                { label: 'Создано', value: dateToString(item.createdAt) },
              ]}
              editLink={`/events/categories/${item.id}`}
              localizationLink={`/events/categories/${item.id}/localization`}
              onDelete={() => handleDelete(item.id)}
            />
          ))
        )}
      </div>

      <Pagination
        count={data.totalCount}
        itemsPerPage={5}
        onChange={(page) => getData(5, 5 * page)}
      />
    </>
  );
};

export default CategoriesOfEventsPage;
